var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(-336 -143)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(336 143)",
    fill: "#194039"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 0.972,
    cy: 0.972,
    r: 0.972,
    transform: "translate(342.028 146.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M200.618,193.929v3.2a.809.809,0,0,1-1.618,0v-3.2a.809.809,0,1,1,1.618,0Z",
    transform: "translate(143.191 -44.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Zm4.07,11.07A5.756,5.756,0,0,1,2.861,3L2.93,2.93A5.756,5.756,0,1,1,11.139,11Z",
    transform: "translate(336 143)",
    fill: "#194039"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.41e298442cb33f767c28653d5906349e.svg";
export { ForwardRef as ReactComponent };